import * as R from 'ramda'
import axios from 'axios'
import {create, load_many, load_one, update, _get_counts} from '../action-helpers'
import http from '@/http'

// noinspection JSUnusedGlobalSymbols
export default {

    /**
     * Lädt genau eine Seite Produkte vom Server (echte server-seitige Paginierung).
     * Gibt das Array der Produkte auf dieser Seite zurück.
     */
    async loadPage({ commit }, { page = 0, size = 25, status, sortDirection = 'desc' } = {}) {
        const params = { page, size, sort: `id,${sortDirection}` }
        if (status && status !== 'ALL') {
            params.status = status
        }
        const response = await http({ method: 'GET', url: 'products', params })
        const products = response.data.content
        commit('SET_MANY', { content: products })
        commit('SET_COUNTS', { content: _get_counts(response.headers) })
        return products
    },

    /**
     * Lädt eine Seite archivierter Produkte vom Server.
     * Gibt { products, totalElements } zurück.
     * SET_COUNTS wird bewusst nicht gesetzt, um die Live-Produkt-Counts nicht zu überschreiben.
     */
    async loadPageArchived({ commit }, { page = 0, size = 25, sortDirection = 'desc' } = {}) {
        const params = { page, size, sort: `id,${sortDirection}`, isArchived: true }
        const response = await http({ method: 'GET', url: 'products', params })
        const products = response.data.content
        commit('SET_MANY', { content: products })
        return { products, totalElements: response.data.totalElements }
    },

    cancel: update('products/:id/cancel'),
    archive: update('products/:id/archive'),
    create: create('products'),
    loadAll: load_many('products', { setCounts: true }),
    loadAllByStatus: load_many('products', { params: { status: ':status' }, setCounts: true }),
    loadAllArchived: load_many('products', { params: { isArchived: 'true' } }),
    loadOne: load_one('products/:id'),
    update: update('products/:id'),

    getSseToken() {
        return axios.post('/api/v1/products/sse-token').then(response => response.data.token)
    },

    loadAllByVariantModels({ dispatch }, { variantModels }) {
        return R.compose(

            // Promises zusammenfassen
            promises => Promise.all(promises),

            // Produkt laden
            R.map(id => dispatch('loadOne', { id })),

            // Produk-ID lesen
            R.map(R.prop('product'))

        )(variantModels)
    },

}


